import { createBaseCrudMachine } from '~/machines/base-crud';
import { MalpracticeClaim } from '~/types';
import { API_CALLS } from './api';
import { emptyMalpracticeClaimForm } from './constants';
import { ClaimsSort, MalpracticeClaimFormValues } from './types';

export const claimsMachine = createBaseCrudMachine<
  MalpracticeClaim,
  MalpracticeClaimFormValues,
  ClaimsSort
>({
  initialForm: emptyMalpracticeClaimForm,
  sort: {
    sortBy: 'id',
    occurrence_date: -1,
    claim_status: -1,
    settlement_amt: -1,
    liability_carrier: -1,
    id: 1,
    page: 1,
    pageSize: 100,
  },
  apiCalls: API_CALLS,
});
